import React from 'react';

type LogoProps = {
  src: string;
  alt?: string;
  className?: string;
};

const WebsiteLogo: React.FC<LogoProps> = ({
  src,
  alt = 'Logo',
  className = 'h-20 w-auto'
}) => {
  if (!src) return null;
  return <img src={src} alt={alt} className={className} />;
};

export default WebsiteLogo;
